import React from 'react'
import PropTypes from 'prop-types'
import { Button as StrapButton } from 'reactstrap'

const Button = props => (
  <StrapButton
    className={`btn ${props.class}`}
    style={props.style}
    onClick={props.click}
    type={props.type}
    {...(props.link && { color: 'link' })}
    disabled={props.disabled}
  >
    {props.text}
    {props.icon && <i className={`fa ${props.icon}`}></i>}
  </StrapButton>
)

Button.propTypes = {
  class: PropTypes.string.isRequired,
  style: PropTypes.object,
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,
  click: PropTypes.func,
  type: PropTypes.string,
  link: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default Button
